<template>
  <div>
    <div class="app-card-header primary-actions">
      <div class="heading-block">
        <h4 class="heading">Price Tracking</h4>
      </div>
      <div class="actions-block">
        <!--Seller Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            :value="chart.sellers.checked"
            :items="chart.sellers.all"
            :loading="filters.seller.isLoading"
            :ripple="false"
            :disabled="copyChart().status.loading"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            single-line
            hide-details
            clear-icon
            placeholder="Sellers"
            append-icon="expand_more"
            item-text="name"
            item-value="id"
            label="Sellers"
            solo
            flat
            multiple
            class="placeholder-hardcoded"
            @change="checkSeller($event)"
          >
            <template v-slot:selection="data">
            </template>
          </v-autocomplete>
        </div>
        <!--Date Pick-->
        <div class="dropdown-filter min">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                flat
                small
                :disabled="copyChart().status.loading"
                :ripple="false"
                v-on="on"
              >
                <v-icon class="mr-1">event</v-icon>{{filters.date.modelText}}
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                v-for="(item, index) in filters.date.items"
                :key="index"
                @click="filterDate($event, item.key, item.value)"
              >
                <v-list-tile-title>{{ item.value }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>
    <div class="card-body pa-0">
      <v-progress-circular
        v-if="copyChart().status.loading && copyChart().status.noData"
        :indeterminate="true"
        :size="75"
        height="3"
        color="primary"
        class="progress-circular" />
      <v-progress-linear
        v-if="copyChart().status.loading && !copyChart().status.noData"
        :indeterminate="true"
        height="3"
        color="primary"
        class="progress-card" />
      <apexchart
        v-if="!copyChart().status.noData"
        type="area"
        ref="priceTrackingChart"
        class="line-chart price-tracking-chart"
        height="420"
        :options="copyChart()"
        :series="copyChart().series" />
      <i-no-data v-if="copyChart().status.noData && !copyChart().status.loading" title="No data found or no mapping" heading="Oops!" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'priceTracking',
  props: {
    filters: {
      type: [Object, Array],
      default: null
    },
    chart: {
      type: [Object, Array],
      default: null
    },
    currentProduct: {
      type: [Object, Array],
      default: null
    },
    currentSku: {
      type: [Object, Array],
      default: null
    }
  },
  methods: {
    filterDate (e, key, value) {
      this.filters.date.model = key
      this.filters.date.modelText = value
    },
    copyChart () {
      return JSON.parse(JSON.stringify(this.chart.chartOptions))
    },
    resetFilter () {
      this.filters.seller.model = 0
      this.filters.date.model = 1
      this.filters.date.modelText = 'Last 24 Hours'
    },
    checkSeller (items) {
      this.$store.commit('productViewModule/ADD_priceTrackingSellers', {item: items})
      this.$store.dispatch('productViewModule/getPriceTracking', {
        productId: this.currentProduct.id,
        sku: this.currentSku.sku,
        sellerId: items,
        altDate: this.filters.date.model,
        moduleId: 1,
        chartRef: this.$refs.priceTrackingChart
      })
    }
  },
  watch: {
    'filters.date.model': function (val) {
      this.$store.dispatch('productViewModule/getPriceTracking', {
        productId: this.currentProduct.id,
        sku: this.currentSku.sku,
        sellerId: this.chart.sellers.checked,
        altDate: this.filters.date.model,
        moduleId: 1,
        chartRef: this.$refs.priceTrackingChart
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/productView/priceTracking.vue